import React from "react";
import { formatDate } from "../../utils/formatDate ";
import { useTranslation } from "react-i18next";
import UAEDirhamIcon from "../../utils/UAEDirhamIcon";
import { OrderStatus } from "../../../enum/orderStatus";
import Visibility from "../../utils/Visibility";

function OrderElement({ onClick, order, name }: any) {
  const { id, price, note, created_at, num_order, status } = order;
  const formattedDate = formatDate(created_at);
  const { t } = useTranslation();

  return (
    <div
      className="border-2 border-border p-4 md:p-5 rounded-xl shadow-md bg-card flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 cursor-pointer hover:shadow-lg hover:border-primary/30 transition-all duration-300"
      onClick={() => onClick(order)}
    >
      <div className="flex-1 min-w-0 space-y-2 md:space-y-2.5">
        <h3 className="text-lg md:text-xl font-bold text-foreground">
          {t("gloabl.order")} #{num_order}
        </h3>
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-sm md:text-base">
          <p className="flex items-center gap-1.5">
            <span className="font-semibold text-muted-foreground">{t("gloabl.value")}:</span>
            <span dir="ltr" className="flex items-center gap-1 font-semibold text-primary">
              <UAEDirhamIcon className="w-3 h-3 md:w-4 md:h-4" />
              {price}
            </span>
          </p>
          <p className="text-muted-foreground">
            <span className="font-semibold">{t("gloabl.date")}:</span> {formattedDate}
          </p>
        </div>
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs md:text-sm text-muted-foreground">
          <p className="truncate">
            <span className="font-semibold">{t("gloabl.name")}:</span> {order.customer_name || "___"}
          </p>
          <p className="truncate">
            <span className="font-semibold">{t("contact.phone")}:</span>{" "}
            <span dir="ltr">{order.customer_phone || "___"}</span>
          </p>
        </div>
        <Visibility visible={!!note}>
          <p className="text-xs md:text-sm text-muted-foreground truncate">
            <span className="font-semibold">{t("gloabl.Notes")}:</span> {note || t("gloabl.noNotes")}
          </p>
        </Visibility>
      </div>
      <div
        className={`px-3 md:px-4 py-2 rounded-full text-xs md:text-sm font-semibold border-2 flex-shrink-0 ${getStatusColor(
          status
        )}`}
      >
        {t(`orderStatus.${status}`)}
      </div>
    </div>
  );
}

export default OrderElement;
export const getStatusColor = (status: string) => {
  switch (status) {
    case OrderStatus.pending:
      return "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-300 border-yellow-300 dark:border-yellow-700";
    case OrderStatus.processing:
      return "bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-300 border-blue-300 dark:border-blue-700";
    case OrderStatus.completed:
      return "bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-300 border-green-300 dark:border-green-700";
    case OrderStatus.canseled:
      return "bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-300 border-red-300 dark:border-red-700";
    default:
      return "bg-muted text-muted-foreground border-border";
  }
};
